import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { FaUser } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import { FaMoneyBill } from "react-icons/fa";
import { TbArrowsUpDown } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import { getBrokeragesList, loadBrokerages } from "../../store/brokerages";
import { Pagination } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  ArcElement,
  Legend,
} from "chart.js";
import { Bar, Pie, Line } from "react-chartjs-2";
import _ from "lodash";

const BAR = "BAR";
const LINE = "LINE";
const PIE = "PIE";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const StatisticCard = (props) => {
  const cardInfo = props.cardInfo;

  return (
    <>
      <Card
        onClick={() => {
          props.setSelectedCard(cardInfo.view);
        }}
        style={{
          display: "inline-block",
          width: cardInfo.width ? cardInfo.width : "10rem",
          margin: cardInfo.margin ? cardInfo.margin : "10px",
          backgroundColor: "white",
        }}
      >
        <Card.Img
          variant="top"
          //   src="https://www.toptal.com/designers/subtlepatterns/uploads/moroccan-flower.png"
        />
        {/* <Card.ImgOverlay> */}
        <Card.Body>
          <Container>
            <Row className="justify-content-md-center">
              <Col className="d-flex justify-content-center align-items-center flex-column  gap-3">
                {cardInfo.icon && (
                  <span style={{ marginBottom: "20px" }}>
                    <cardInfo.icon size={"34px"} />
                  </span>
                )}
                <span>
                  <h6>{cardInfo.title}</h6>
                </span>
                <span>
                  <h4>{cardInfo.data} </h4>
                </span>
              </Col>
            </Row>
          </Container>
        </Card.Body>
        {/* </Card.ImgOverlay> */}
      </Card>
    </>
  );
};

const StatisticTable = ({
  data,
  headers,
  itemsPerPage,
  handleRowClick,
  view,
  keyField,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleClick = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total number of pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Get the data for the current page
  const currentData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      {/* <Table hover>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, index) => (
            <tr onClick={() => handleRowClick({ ...item, view })} key={index}>
              {headers.map((header, i) => {
                let value = _.get(item, header.field); // use lodash's get method

                if (
                  typeof value === "object" &&
                  !Array.isArray(value) &&
                  value !== null
                ) {
                  value = "";
                }

                if (header.type === "date" && value) {
                  value = new Date(value).toLocaleDateString();
                } else if (header.type === "array" && value) {
                  value = value.length;
                } else if (header.type === "boolean" && value) {
                  
                  value = value ? "yes" : "no";
                }

                return <td key={i}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center">
        <Pagination>
          {currentPage > 1 && (
            <Pagination.Item onClick={() => handleClick(1)}>
              {1}
            </Pagination.Item>
          )}

          {currentPage > 3 && <Pagination.Ellipsis disabled />}

          {[...Array(totalPages)].map((_, i) => {
            if (
              (currentPage <= 3 && i < 5) || // Show first 5 pages when current page is less than or equal to 3
              (currentPage > 3 &&
                i >= currentPage - 2 &&
                i <= currentPage + 2) || // Show 5 pages centered around the current page
              (currentPage >= totalPages - 2 && i >= totalPages - 5) // Show last 5 pages when current page is near the end
            ) {
              return (
                <Pagination.Item
                  key={i}
                  active={i + 1 === currentPage}
                  onClick={() => handleClick(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              );
            }

            return null;
          })}

          {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}

          {currentPage < totalPages && (
            <Pagination.Item onClick={() => handleClick(totalPages)}>
              {totalPages}
            </Pagination.Item>
          )}
        </Pagination>
      </div> */}

      <BootstrapTable
        keyField={keyField}
        data={data}
        columns={headers}
        pagination={paginationFactory()}
        filter={filterFactory()}
        rowEvents={{
          onClick: (e, row, rowIndex) => {
            handleRowClick({ ...row, view });
          },
        }}
      />
    </>
  );
};

const ReportsChart = (props) => {
  const reportData = props.reportData;
  const reportTitle = props.reportTitle;
  const reportChartType = props.reportChartType;
  const [chartData, setChartData] = useState(null);
  const options = {
    responsive: true,
    maintainAspectRatio: props.maintainAspectRatio ? true : false,
    plugins: {
      legend: {
        display: props.legend,
        position: "bottom",
      },
      title: {
        display: true,
        text: reportTitle,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            label += props.isPercentage
              ? Math.round(context.parsed.y * 100) / 100 + "%"
              : context.parsed.y;
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: props.isStacked ? true : false,
      },
      y: {
        stacked: props.isStacked ? true : false,
        ticks: {
          // Include a % sign in the ticks
          callback: function (value) {
            return props.isPercentage ? `${value}%` : value;
          },
        },
      },
    },
  };
  const optionsPie = {
    responsive: true,
    maintainAspectRatio: props.maintainAspectRatio ? true : false,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: false,
        text: reportTitle,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label
              ? context.dataset.label + ": "
              : "";
            label += props.isPercentage ? context.parsed + "%" : context.parsed;
            return label;
          },
        },
      },
    },
  };

  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
  ];

  useEffect(() => {
    if (reportData && reportData.labels && reportData.datasets) {
      // Add a random color to each dataset if it doesn't have a color
      const datasets = reportData.datasets.map((dataset) => {
        var randomColor = getRandomColor();
        return {
          ...dataset,
          backgroundColor: dataset.backgroundColor || randomColor,
          borderColor: randomColor,
        };
      });

      setChartData({
        labels: reportData.labels,
        datasets: datasets,
      });
    }
  }, [reportData]);

  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  return (
    <>
      {chartData && (
        <>
          {reportChartType === LINE ? (
            <div style={{ height: "500px", width: "100%" }}>
              <Line options={options} data={chartData} />
            </div>
          ) : reportChartType === BAR ? (
            <div style={{ height: "500px", width: "100%" }}>
              <Bar
                options={options}
                data={chartData}
                height={undefined}
                width={undefined}
              />
            </div>
          ) : (
            <div style={{ width: "90%" }}>
              <Pie options={optionsPie} data={chartData} />{" "}
            </div>
          )}
        </>
      )}
    </>
  );
};

export { StatisticCard, StatisticTable, ReportsChart };
